import { Component, useCallback } from 'react'
import GetLabelButton from '~/components/OrdersPage/GetLabelButton'
import Tabs from '~/components/OrdersPage/Tabs'
import Measurements from '~/utils/Measurements'
import OrderListLongPolling from '~/utils/OrderListLongPolling'
import { Map } from '~/components'
import { postData } from '~/utils/api'
import { useToasts } from 'react-toast-notifications'
import { getItemsCount } from '~/utils/helpers'
import styles from '~/styles/ordersPage.modal.module.css'
import types from '~/types/ordersPage.ts'

export default class Modal extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {
			showWarning: false,
			showMap: false,
			preventWarningUntill: null,
			isOkButtonDisabled: false,
			isReasonRequired: true,
			isReasonShown: false,
		}
		this.orderListLongPolling = new OrderListLongPolling(this.props.setOrderListUpdater)
	}
	
	render(): JSX.Element | null {
		if (this.props.isOpen) {
			if (!this.state.showMap) {
				let isOkButtonDisabled = (this.state.isOkButtonDisabled || !this._isOrderOk())
				const okClassName = styles.okButton + ' ' + styles.button + (isOkButtonDisabled ? ' ' + styles.disabled : '')
				return (
					<div
						className={styles.main}
					>
						<div>
							<div
								className={styles.body}
							>
								<Tabs
									order={this.props.order}
									editTheOrder={this.props.editTheOrder}
									onWarningChange={this._onWarningChange.bind(this)}
									choosePointType={this.state.choosePointType}
									showMap={this._showMap.bind(this)}
									setUpdatePoints={this.props.setUpdatePoints}
									setPackageFind={this._setPackageFind.bind(this)}
									t={this.props.t}
									locale={this.props.locale}
									currentDealer={this.props.currentDealer}
									authDealerId={this.props.authDealerId}
									isRu={this.props.isRu}
								/>
							</div>
							<div
								className={styles.warning + (this.state.showWarning ? (' ' + styles.show) : '')}
							>
								<div>
									<div>
										{this.props.t('Are you sure?')}
									</div>
									<div>
										<div
											className={styles.button}
											onClick={this._onWarningCancel.bind(this)}
										>
											{this.props.t('No')}
										</div>
										<div
											className={styles.button}
											onClick={this._onWarningOk.bind(this)}
										>
											{this.props.t('Yes')}
										</div>
									</div>
								</div>
							</div>
							<div
								className={styles.xButton}
								onClick={this._onCancel.bind(this)}
							/>
							<div
								className={styles.footer}
							>
								{this._getLabelsButtons()}
								{this._getReasonForSave()}
								<div
									className={okClassName}
									onClick={this._onOk.bind(this, false)}
								>
									{this._getOkButton()}
								</div>
							</div>
						</div>
					</div>
				)
			} else {
				let address = (this.props.order.manuallyEnteredCustomerAddress || '')
				if (!address && !(this.state.pointId || this.props.order.clickedByShowOnMapPointId)) {
					if (this.props.order.pointAddress && this.props.order.pointDescription) {
						address = this.props.order.pointAddress + ', ' + this.props.order.pointDescription
					}
				}
				const dimensionalMU = this.props.order.dealer_dimensions_mu
				const weightMU = this.props.order.dealer_weight_mu
				const measurements = new Measurements(dimensionalMU, weightMU)
				const { muLength, muWidth, muHeight, muWeight } = measurements.getByOrder(this.props.order)
				let itemsPriceWithDiscount = +(this.props.order?.in_cost) || 0
    				itemsPriceWithDiscount += +(this.props.order?.discount_included) || 0
    			if (!itemsPriceWithDiscount) {
    				itemsPriceWithDiscount = +(this.props.order?.in_total) || 0 // on new order button
    			}
				return (
					<div
						className={styles.map}
					>
						<div>
							<Map
								handleMapClose={this._closeMap.bind(this)}
								dealerId={this.props.order.shipperId || this.props.order.dealerId}
								orderCost={itemsPriceWithDiscount}
								orderLength={Math.round(muLength * 100) / 100}
								orderWidth={Math.round(muWidth * 100) / 100}
								orderHeight={Math.round(muHeight * 100) / 100}
								orderWeight={Math.round(muWeight * 100) / 100}
								dimUnits={this.props.order.dealer_dimensions_mu}
								weightUnits={this.props.order.dealer_weight_mu}
								address={address}
								currency={this.props.order.currency || 'USD'}
								pointId={this.state.pointId || this.props.order.clickedByShowOnMapPointId || ''}
								items_cnt={getItemsCount(this.props.order)}
							/>
						</div>
					</div>
				)
			}
		} else {
			return null
		}
	}
	
	componentDidMount() {
		window.addEventListener('message', this._onMap.bind(this))
	}

	componentDidUpdate(prevProps) {
		let hideReason = false
		let showReason = false
		const isSameDealer = prevProps.order?.dealerId === this.props.order?.dealerId
		const previousOrderNumber = prevProps.order?.orderNumber || prevProps.order?.ext_key
		const currentOrderNumber = this.props.order?.orderNumber || this.props.order?.ext_key
		const isSameOrderNumber = previousOrderNumber === currentOrderNumber
		if (!(isSameDealer && isSameOrderNumber)) {
			hideReason = true
		} else {
			const currentStatus = this.props.order?.fulfillmentStatus
			const previousStatus = prevProps.order?.fulfillmentStatus
			if (currentStatus !== previousStatus) {
				if (currentStatus === 'declined') {
					showReason = true
				} else {
					hideReason = true
				}
			}
		}
		if (hideReason || showReason) {
			if (!this.state.isReasonRequired) {
				this.setState({ 
					isReasonRequired: true,
				})
			}
			if (showReason && !this.state.isReasonShown) {
				this.setState({ 
					isReasonShown: true,
				})
			} else if (hideReason && this.state.isReasonShown) {
				this.setState({ 
					isReasonShown: false,
				})
			}
		}
	}
	
	componentWillUnmount() {
		window.removeEventListener('message', this._onMap.bind(this))
	}

	private _getLabelsButtons() {
		let show = true
		let isDisabled = false
		const clientsLabel = this.props.order?.dealerAndChildDealers?.[this.props.order.dealerId]?.clients_label
		if (this.props.order.dealer_country === 'RU') {
			show = false
		} else if (clientsLabel === 'Y') {
			show = false
		} else if (!this._isOrderOk({ isLabelButton: true })) {
			isDisabled = true
		}
		return (
			<div
				className={styles.getLabelsButtons}
			>
				<GetLabelButton
	              show={show}
	              isDisabled={isDisabled}
	              isFormatsShown={true}
	              isAtBottom={true}
	              order={this.props.order}
	              processOrder={this._processOrderWithoutClosingModal.bind(this)}
	              closeModal={this.props.onClose}
	              stage={this.props.stage}
	            />
			</div>
		)
	}

	private async _processOrderWithoutClosingModal(): void {
		const result = await this._onOk(true)
		return result
	}

	private _getReasonForSave() {
		if (this.state.isReasonShown) {
			return (
				<div
					className={styles.reasonForSave}
				>
					<textarea
						rows={1}
						onKeyDown={this._onReason.bind(this)}
						placeholder={this.props.t('Reason')}
					/>
					<div
						className={this.state.isReasonRequired ? null : styles.hidden}
					>
						{this.props.t('common:Required')}
					</div>
				</div>
			)
		} else {
			return (
				<div
					className={styles.cancelButton + ' ' + styles.button}
					onClick={this._onCancel.bind(this)}
				>
					{this.props.t('Cancel')}
				</div>
			)
		}
	}

	private _onReason(event) {
		if (this._reasonST) {
			clearTimeout(this._reasonST)
		}
		this._reasonST = setTimeout(() => {
			const value = event.target.value?.trim('')
			if (value.length > 3) {
				if (this.state.isReasonRequired) {
					this.setState({ isReasonRequired: false })
				}
			} else {
				if (!this.state.isReasonRequired) {
					this.setState({ isReasonRequired: true })
				}
			}
			this.props.editTheOrder({ reason: value })
		}, 600)
	}
	
	private _showMap(pointNumber, choosePointType): void {
		this.setState({
			showMap: true,
			pointId: this.props.order?.points?.[pointNumber]?.id || '',
			choosePointType,
		})
	}
	
	private _closeMap(): void {
		this.setState({ showMap: false })
	}
	
	private _onMap({ data: json }): void {
		try {
			if (json) {
				const point = JSON.parse(json)
				if (point.lat && point.lng) {
					let newData = {
						points: [ point ],
						selectedPointNumber: null,
						selectedPointId: point.id,
						in_point: point.id,
						in_delivery_cost: point.price,
					}
					if (this.state.choosePointType === 'customerAddressCheckOnMap') {
						if (!this.props.order?.manuallyEnteredCustomerAddress) {
							const address = (point?.full_address || '') + (point?.full_address ? ', ' : '') + (point?.description || '')
							newData['manuallyEnteredCustomerAddress'] = address
						}
					}
					this.props.editTheOrder(newData)
					this._closeMap()
				}
			}
		} catch(e) {}
	}

	private _setPackageFind(callback): void {
		if (typeof callback === 'function') {
			// this._chargeableWeightUpdater = callback.bind(this)
		}
	}
	
	private _onWarningChange(callback, value): void {
		this._onWarningChangeCallbackObject = { callback, value }
		if ((this.state.preventWarningUntill || Date.now()) <= Date.now()) {
			this.setState({ showWarning: true })
		} else {
			this._onWarningOk()
		}
	}
	private _onWarningOk(): void {
		if (this._onWarningChangeCallbackObject) {
			const { callback, value } = this._onWarningChangeCallbackObject
			callback(value)
			this.setState({
				showWarning: false,
				preventWarningUntill: (Date.now() + 1000 * 60)
			})
		} else {
			this.setState({ showWarning: false })
			if (this.props.onClose) {
				this.props.onClose()
			}
		}
	}
	private _onWarningCancel(): void {
		this._onWarningChangeCallbackObject = null
		this.setState({ 
			showWarning: false,
			preventWarningUntill: null,
		})
	}
	
	private _getOkButton(): JSX.Element {
		if (this.props.order?.onEdit) {
			return (
				this.props.t('Save')
			)
		} else {
			return (
				this.props.t('Create New Order')
			)
		}
	}
	
	private _onCancel(): void {
		if (this.props.order?.isIntact) {
			if (this.props.onClose) {
				this.props.onClose()
			}
		} else {
			this.setState({ showWarning: true })
		}
	}
	
	private async _onOk(isClosingPrevented): void {
		let data
		if (isClosingPrevented) {
			data = { isLabelButton: true }
		}
		if (this._isOrderOk(data)) {
			await this._fillEmptyItems()
			await this._setItemToMu()
			this.setState({ isOkButtonDisabled: true })
			const currentDate = Date.now()
			this.orderListLongPolling.updateOrderList(currentDate)
			const requestUrl = '/api/v1/order'
			this.props.onAction.send({
				action: 'Create New Order button',
		        actionData: {
		          file: 'components/OrdersPage/Modal.tsx',
		          requestUrl,
		          order: this.props.order
		        },
			})
			const data = {
				session: this.props.session,
				uuid: this.props.order.authDealerId || this.props.order.dealerId,
				dealer_token: this.props.dealer_token,
				order: this.props.order,
				origin: window?.location?.origin,
				currentDate,
			}
			const result = await this._orderProcessRequest(requestUrl, data, isClosingPrevented)
			return result
		}
	}

	private _orderProcessRequest(requestUrl, data, isClosingPrevented) {
		return new Promise(async success => {
			await postData(requestUrl, data).then(result => {
				this.setState({ isOkButtonDisabled: false })
				if (typeof result === 'object') {
					if (result.error) {
						if (result.error === 'Wrong shop identity params') {
							this.props.addToast(this.props.t('Your account has been locked'), { appearance: 'error' })
							this.props?.onClose()
						} if (typeof result.error === 'string') {
							this.props.addToast(result.error, { appearance: 'error' })
						} else {
							this.props.addToast(this.props.t('Something went wrong'), {appearance: 'error'})
						}
					} else {
						this.props.addToast(this.props.t('New order has been created'), { appearance: 'success' })
						if (!isClosingPrevented) {
							this.props?.onClose()
						}
						success(result)
					}
				} else {
					this.props.addToast(this.props.t('Something went wrong'), {appearance: 'error'})
				}
				success()
			}).catch(error => {
				this.props.addToast(this.props.t('Could not create a new order'), { appearance: 'error' })
				this.setState({ isOkButtonDisabled: false })
			})
		})
	}
	
	private _fillEmptyItems(): void {
		const order = this.props.order
		if (order?.hasDefaultItem && Object.keys(order?.orderItems || {}).length === 1) {
			if (order?.paid) {
				const weightGr = order?.defaultPackageWeightGr || 100
				const lengthMm = order?.defaultPackageLengthMm || 200
				const widthMm = order?.defaultPackageWidthMm || 200
				const heightMm = order?.defaultPackageHeightMm || 100
				return new Promise(resolve => {
					const newItems = {
						0: {
							_id: 123456,
							line_num: 0,
							title: "Item",
							weight: order?.defaultPackageWeightGr || 100,
							length: order?.defaultPackageLengthMm || 200,
							width: order?.defaultPackageWidthMm || 200,
							height: order?.defaultPackageHeightMm || 100,
							barcode: null,
							quantity: 1,
							price: 1,
							vat: 20,
							total_price: 1,
							_isDefautItem: true,
						},
						1: {
							_id: 123456,
							line_num: 1,
							title: this.props.t('Default Package'),
							weight: weightGr,
							length: lengthMm,
							width: widthMm,
							height: heightMm,
							barcode: null,
							quantity: 1,
							price: order?.in_total || 0,
							vat: -1,
							total_price: order?.in_total || 0,
						},
					}
					this.props.editTheOrder('orderItems', newItems)
					setTimeout(() => {
						resolve()
					})
				})
			}
		}
	}

	private _setItemToMu() {
		return new Promise(resolve => {
			const order = this.props.order
			const orderItems = order?.orderItems
			const measurements = new Measurements(order?.dealer_dimensions_mu, order?.dealer_weight_mu)
			const newItems = {}
			Object.keys(order.orderItems || {}).forEach(i => {
				const item = order.orderItems[i]
				const newItem = JSON.parse(JSON.stringify(item))
				newItem['length'] = measurements.mmToMu(+item['length'])
				newItem['width'] = measurements.mmToMu(+item['width'])
				newItem['height'] = measurements.mmToMu(+item['height'])
				newItem['weight'] = measurements.grToMu(+item['weight'])
				newItems[i] = newItem
			})
			this.props.editTheOrder('orderItems', newItems)
			setTimeout(() => {
				resolve()
			})
		})
	}
	
	private _isOrderOk(data): boolean {
		const ok01 = !!(this.props.order?.in_length && this.props.order?.in_width && this.props.order?.in_height)
		const ok02 = !!(this.props.order?.in_total ||  this.props.order?.in_total === 0)
		const ok03 = !!((this.props.order.in_weight || this.props.order.mu_in_weight) && this.props.order?.in_point)
		const isNoItems = !!(this.props.order?.hasDefaultItem && Object.keys(this.props.order?.orderItems || {}).length === 1)
		const isPaid = this.props.order?.paid
		const ok04 = (!isNoItems || (isNoItems && isPaid))
		const ok05 = !!(this.props.order?.in_cust_name && this.props.order?.in_cust_email && this.props.order?.in_cust_phone)
		const ok06 = !!(this.props.order && this.props.order.hasOwnProperty('mu_in_length') && this.props.order.hasOwnProperty('mu_in_width') && this.props.order.hasOwnProperty('mu_in_height') && this.props.order.hasOwnProperty('mu_in_weight') && this.props.order.hasOwnProperty('dealer_dimensions_mu') && this.props.order.hasOwnProperty('dealer_weight_mu'))
		let ok07 = true
		if (this.props.order.fulfillmentStatus === 'declined') {
			if (!this.props.order.reason){
				if (!this.state.isReasonShown) {
					this.setState({ isReasonShown: true })
				}
				ok07 = false
			}
		}
		let ok08 = (!this.props.order?.points || this.props.order.points.length)
		let ok09 = true
		if (this.props.order.initial && !data?.isLabelButton) {
			const orderCopy = JSON.parse(JSON.stringify(this.props.order))
			delete orderCopy.initial
			delete orderCopy.packageWeightMu
			delete orderCopy.autoPackageCode
			delete orderCopy.autoPackageDimensions
			if (JSON.stringify(this.props.order.initial) === JSON.stringify(orderCopy)) {
				ok09 = false // the same
			}
		}
		const phoneString = (this.props.order?.in_cust_phone + '')
		const phoneLength = phoneString.replace(/\D+/g, '').length
		let isPhoneLengthOk = false
		const isBelarus = phoneString.startsWith('375')
		const isKyrgyzstan = phoneString.startsWith('996')
		const isKazakhstan = phoneString.startsWith('997')
		if (isBelarus || isKyrgyzstan || isKazakhstan) {
			isPhoneLengthOk = (phoneLength === 12)
		} else {
			isPhoneLengthOk = (phoneLength >= 11)
		}
		return !!(ok02 && ok03 && ok04 && ok05 && ok06 && ok07 && ok08 && ok09 && isPhoneLengthOk)
	}
}